import React, { useState, useEffect } from 'react';
import { Grid, TextField, Button } from "@mui/material";
import { crearOficina, actualizarOficina } from '../services/oficinas.service';

const OficinasForm = ({ 
    setIsVisibleModal,
    reload,
    setReload,
    oficina
    }) => {
    const [oficinaData, setOficinaData] = useState({});

    useEffect(() => {
        if (oficina) { 
            setOficinaData({
                id_oficina: oficina?.id,
                nombre: oficina?.nombre || ''
            });
        } else {
            // Reiniciar el estado para un nuevo usuario
            setOficinaData({
                id: null,
                nombre: ''
            });
        }
    }, [oficina]);
    

    const handleOficinaSubmit = (e) => {
        e.preventDefault(); 
        if (oficinaData.id) {
            console.log("Actualización", oficinaData);
            actualizarOficina(oficinaData.id, oficinaData)
            .then(() => {
                setIsVisibleModal(false);
                setReload(!reload);
            });
        } else {
            console.log("Nueva oficina", oficinaData);
            crearOficina(oficinaData)
            .then(() => {
                setIsVisibleModal(false);
                setReload(!reload);
            });
        }

    };     

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setOficinaData((prevState) => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    };


    return (
        <form onSubmit={handleOficinaSubmit}>          
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            label="Nombre"
                            name="nombre"
                            size="small"
                            value={oficinaData.nombre}
                            onChange={handleChange}
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Button type="submit" variant="contained" color="primary">
                            {oficina ? 'Actualizar' : 'Crear'} Oficina
                        </Button>
                    </Grid>
                </Grid>                 
        </form>
    );
};

export default OficinasForm;
